<ng-container *ngIf="regionState$ | async as state">
  <div class="region-search">
    <mat-form-field class="address-search" (click)="hideUserAddresses$.next(false)">
      <mat-label>
        <fa-icon icon="map-pin" xIconSize="small"></fa-icon>
        <span i18n="@@RegionOverlay.RegionSearch.Label">
          Search your address to match a delivery area...
        </span>
      </mat-label>
      <x-address-autocomplete
        [formControl]="addressSearchControl"
        [countryCode]="defaultCountryCode$ | async"
      >
        <x-input-loader *xAddressLoader></x-input-loader>
        <x-region-user-addresses
          xSavedAddresses
          [addresses]="(userAddresses$ | async) ?? []"
          (addressSelected)="userAddressSelected($event)"
        ></x-region-user-addresses>
      </x-address-autocomplete>
    </mat-form-field>

    <ng-content select="[xAction]"></ng-content>
  </div>

  <!--  <ng-container *ngIf="!regionService.tempRegionState">-->
  <div class="login mat-caption" *xIfLoggedOut>
    <a xLinkColor="default" (click)="regionService.login(state.productContext)">
      <ng-container i18n="@@CallToAction.Login">Login</ng-container>
    </a>
    <span>
      &nbsp;
      <ng-container i18n="@@RegionOverlay.RegionSearch.LoginToSeeSavedAddresses.Note">
        to see your saved addresses in the search results.
      </ng-container>
    </span>
  </div>
  <!--  </ng-container>-->
</ng-container>
